import ErrorRoundedIcon from "@mui/icons-material/ErrorRounded";
import { IconProps } from "./types";

export function ErrorIcon({ size, ...props }: IconProps) {
    return <ErrorRoundedIcon fontSize={size} {...props} />;
}
